var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-inner"},[_c('div',{staticClass:"top py-3"},[_c('strong',[_vm._v("Řízení elektrické energie")])]),_c('div',{staticClass:"bottom"},[_c('div',{attrs:{"id":"energy-widget"}})])])
}]

export { render, staticRenderFns }